import { FormGroup, Input, Label } from 'reactstrap';
import { SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { AIModel, AIConfig, AIModelInfoMap } from '@g17eco/types/ai';
import './styles.scss';

const aiModelOptions = Object.values(AIModel).map((model) => {
  const { label, icon } = AIModelInfoMap[model];
  return {
    label: (
      <span>
        {icon ? <i className={`${icon} me-1`} /> : null}
        {label}
      </span>
    ),
    value: model,
  };
});

interface Props {
  form?: AIConfig;
  onChangeForm: (data: Partial<AIConfig>) => void;
  placeholder?: string;
}

export const AIInstructionsForm = ({
  form,
  onChangeForm,
  placeholder = 'Pass additional information or instructions to the AI to change the tone or improve its response by giving it extra data.',
}: Props) => {
  return (
    <>
      <FormGroup>
        <Label className='fs-6 text-ThemeTextDark' for='aiInstruction'>
          AI Instructions
        </Label>
        <Input
          id='aiInstruction'
          type='textarea'
          rows={4}
          maxLength={500}
          placeholder={placeholder}
          value={form?.additionalContext ?? ''}
          onChange={(e) => onChangeForm({ additionalContext: e.target.value })}
        />
        <span className='text-sm text-ThemeTextPlaceholder'>
          Controls tone, focus areas, and content emphasis. Layout, structure and field lengths are fixed.
        </span>
      </FormGroup>
      <FormGroup>
        <Label className='fs-6 text-ThemeTextDark'>Model</Label>
        <SimpleTooltip text='New models coming soon'>
          <SelectFactory
            selectType={SelectTypes.SingleSelect}
            options={aiModelOptions}
            value={aiModelOptions.find((op) => op.value === form?.aiModel) ?? aiModelOptions[0]}
            onChange={(e) => onChangeForm({ aiModel: e?.value })}
            isDisabled
          />
        </SimpleTooltip>
      </FormGroup>
    </>
  );
};
